/** @format */

import {forwardRef} from 'react';

import classNames from 'classnames';
import {Icon} from '@sttark/design-system';

export const Button = forwardRef(
    (
        {
            primary,
            secondary,
            tertiary,
            destructive,
            small,
            large,
            label,
            iconLeft,
            iconRight,
            onClick,
            className,
            fullWidth,
            disabled,
            url,
            openUrlOnNewWindow,
            ...props
        },
        ref
    ) => {
        const isPrimary = primary || (!secondary && !tertiary);
        const buttonClasses = classNames(
            'btn',
            {
                'w-100': fullWidth,
                'btn--primary': isPrimary,
                'btn--primary-destructive': isPrimary && destructive,
                'btn--secondary': secondary,
                'btn--tertiary': tertiary,
                'btn--icon-right': iconRight,
                'btn--icon-left': iconLeft,
                'd-flex align-items-center justify-content-center': iconLeft || iconRight,
                'btn--large': large,
                'btn--small': small
            },
            className
        );

        const iconColor = secondary || tertiary ? 'black' : 'white';

        return (
            <div>
                {!url && onClick && (
                    <button
                        ref={ref}
                        disabled={disabled}
                        className={buttonClasses}
                        onClick={onClick}
                        {...props}>
                        {iconLeft && (
                            <div className="icon me-1 d-flex align-items-center justify-content-center flex-shrink-0 ps-3">
                                <Icon
                                    type={iconLeft}
                                    small={small}
                                    large={large}
                                    color={iconColor}
                                />
                            </div>
                        )}
                        <span>{label}</span>
                        {iconRight && (
                            <div className="icon ms-1 d-flex align-items-center justify-content-center flex-shrink-0 pe-3">
                                <Icon
                                    type={iconRight}
                                    small={small}
                                    large={large}
                                    color={iconColor}
                                />
                            </div>
                        )}
                    </button>
                )}

                {url && !onClick && (
                    <a
                        href={!disabled && url}
                        target={openUrlOnNewWindow && '_blank'}
                        rel={openUrlOnNewWindow && 'noopener noreferrer'}>
                        <div
                            ref={ref}
                            className={`${buttonClasses} ${disabled && 'disabled'}`}
                            {...props}>
                            {iconLeft && (
                                <div className="icon me-1 d-flex align-items-center justify-content-center">
                                    <Icon
                                        type={iconLeft}
                                        small={small}
                                        large={large}
                                        color={iconColor}
                                    />
                                </div>
                            )}
                            <span>{label}</span>
                            {iconRight && (
                                <div className="icon ms-1 d-flex align-items-center justify-content-center">
                                    <Icon
                                        type={iconRight}
                                        small={small}
                                        large={large}
                                        color={iconColor}
                                    />
                                </div>
                            )}
                        </div>
                    </a>
                )}
            </div>
        );
    }
);

Button.displayName = 'Button';

Button.defaultProps = {
    label: 'Submit'
};
